import * as api from '@api';
import { useState } from 'react';
import { useQuery } from '@/hooks/useApi';
import useToast from '@/hooks/useToast';

export default function useNetworkUsersList() {
  const { toast } = useToast();
  const [data, setData] = useState([]);

  useQuery('getNetworkUsers', () => api.usersGet({ isDropDown: true }), {
    onSuccess: ({ status, error, data }) => {
      if (status >= 400) return toast.error(error.message);
      setData(data?.data);
    },
    gcTime: 600 * 1000,
  });

  return data;
}
